import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Field } from "formik";

export default class FormikCheck extends Component {
  static propTypes = {
    label: PropTypes.string.isRequired,
    icon: PropTypes.string,
    disabled: PropTypes.bool,
    input: PropTypes.shape({
      value: PropTypes.bool.isRequired,
      name: PropTypes.string.isRequired,
      onChange: PropTypes.func.isRequired
    }).isRequired
  };

  static defaultProps = {
    icon: "fa-check-circle",
    onChange: () => null
  };

  state = {
    focused: false
  };

  onFocus = () => {
    this.setState({ focused: true });
  };

  onBlur = () => {
    this.setState({ focused: false });
  };

  render() {
    const { focused } = this.state;
    const { label, name, icon, disabled, parse } = this.props;

    return (
      <Field name={name}>
        {({ field, _meta }) => {
          // Handle parsing on change
          const handleChange = ev => {
            const parsedValue = parse
              ? parse(ev.target.checked)
              : ev.target.checked;
            // Create a new event object with the same properties as the original event
            const newEvent = {
              ...ev,
              target: {
                ...ev.target,
                value: parsedValue,
                name // Ensure the name attribute is included
              }
            };
            field.onChange(newEvent); // Pass the new event object to field.onChange
          };

          const labelClasses = classNames("btn btn-default", {
            active: field.value,
            focus: focused,
            disabled
          });

          return (
            <label className={labelClasses} htmlFor={field.name}>
              <input
                type="checkbox"
                id={field.name}
                checked={field.value}
                onChange={handleChange}
                onBlur={field.onBlur}
                disabled={disabled}
              />
              <i className={`fa fa-lg ${icon}`} />
              &nbsp;&nbsp;{label}
            </label>
          );
        }}
      </Field>
    );
  }
}



// WEBPACK FOOTER //
// ./app/modules/shared/components/Forms/FormikFormInput/FormikCheck.jsx